import React from 'react';
import styled from 'styled-components';

interface SellerSalesProps {
  icon: string;
}

export const SellerSales = ({ icon: Icon }: SellerSalesProps) => (
  <Wrapper>
    <Text>Vendas da loja no último mês</Text>
    <Icon />
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const Text = styled.span`
  display: block;
  font-size: 12px;
  color: #6f6f6f;
  line-height: 12px;
  margin-right: 8px;
`;
